import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { ArrowRight } from "lucide-react";
export default function FinalCtaSection() {
  return <section data-section-id="259303" id="final-cta-section" className="bg-primary text-primary-foreground py-16 md:py-24 lg:py-32">
      <div className="container mx-auto px-4 md:px-6">
        <div className="max-w-4xl mx-auto text-center flex flex-col items-center">
          <h2 className="font-default text-3xl md:text-4xl lg:text-5xl font-bold tracking-tight mb-6">
            Need Roofing or Exterior Services in Your Area?
          </h2>
          
          <p className="text-lg md:text-xl text-primary-foreground/90 mb-4 max-w-2xl font-default">
            Contact Eagle Exteriors today for your free inspection and estimate.
          </p>
        {/*  <p className="text-lg md:text-xl text-primary-foreground/90 mb-4 max-w-2xl font-default">
            Serving [County] for 20+ years
          </p>
          <p className="text-lg md:text-xl text-primary-foreground/90 mb-10 max-w-2xl font-default">
            Local teams available for same-day or next-day consultations
          </p>
          */}
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 w-full sm:w-auto">
            <Button asChild size="lg" className="w-full sm:w-auto text-base h-12 px-8 bg-secondary text-secondary-foreground hover:bg-secondary/90 shadow-md rounded-md">
              <Link to="/ContactPage">
                Request Your Free Local Assessment
                <ArrowRight className="ml-2 size-5" />
              </Link>
            </Button>
            
            <Button asChild variant="outline" size="lg" className="w-full sm:w-auto text-base h-12 px-8 border-secondary text-secondary hover:bg-secondary/10 hover:text-secondary rounded-md">
              <Link to="tel:2408991278">
                Call Now
              </Link>
            </Button>
          </div>
        </div>
      </div>
    </section>;
}